export const COOKIE_NAME = "a4p_cookie_consent";
const CONSENT_VERSION = 1;
const MAX_AGE = 60 * 60 * 24 * 180;

export const DEFAULT_PREFERENCES = Object.freeze({
  necessary: true,
  analytics: false,
  advertising: false,
  social: false,
  behavioralAds: false,
  affiliates: false,
  security: false,
});

export function readCookieConsent(cookieString = typeof document !== "undefined" ? document.cookie : "") {
  const value = cookieString.split(/;\s*/).find((entry) => entry.startsWith(`${COOKIE_NAME}=`))?.slice(COOKIE_NAME.length + 1);
  if (!value) return null;
  try {
    const parsed = JSON.parse(decodeURIComponent(value));
    if (parsed.version !== CONSENT_VERSION || !parsed.preferences) return null;
    return { ...DEFAULT_PREFERENCES, ...parsed.preferences, necessary: true };
  } catch {
    return null;
  }
}

export function persistCookieConsent(preferences) {
  const record = { version: CONSENT_VERSION, updatedAt: new Date().toISOString(), preferences: { ...DEFAULT_PREFERENCES, ...preferences, necessary: true } };
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(JSON.stringify(record))}; Max-Age=${MAX_AGE}; Path=/; SameSite=Lax${secure}`;
}
